import React, { Component } from 'react';

import CountCard from './CountCard';
import TotalOrders from '@material-ui/icons/ShoppingCart';
import CurrentMonthSale from '@material-ui/icons/DateRange';
import TodaysSale from '@material-ui/icons/ViewHeadline';
import TodaysOrderCount from '@material-ui/icons/CheckCircleOutline';
import PreviousMonthSale from '@material-ui/icons/Event';
import TotalSale from '@material-ui/icons/EventNote';
import API from "../../utils/api";
import { Title } from 'react-admin';

const styles = {
    container: { padding: 20 },
    flex: { display: 'flex', flexWrap: 'wrap' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' }
};

const getDashboardData = () => {
    const userType = atob(sessionStorage.getItem("zutp"));
    if (userType === 'MA') {
        const merchantId = sessionStorage.getItem("merchantId");
        return API.fetchEntity(`merchants/${merchantId}/dashboard`,
            { method: "GET" }).catch(e => console.log(e));
    }
    const cityId = sessionStorage.getItem("cityId");
    if (!cityId) {
        return Promise.reject();
    }
    return API.fetchEntity(`cities/${cityId}/city-admin-dashboard`,
        { method: "GET" }).catch(e => console.log(e));
}

class Dashboard extends Component {
    state = {
        todaysOrderCount: '-',
        todaysSale: '-',
        currentMonthSale: '-',
        previousMonthSale: '-',
        totalSale: '-',
        totalOrders: '-'
    };

    componentDidMount() {
        getDashboardData().then(response => {
            if (!response) {
                return;
            }
            const data = response.body;
            if (data) {
                this.setState({
                    currentMonthSale: data.currentMonthSale.toLocaleString(),
                    previousMonthSale: data.previousMonthSale.toLocaleString(),
                    totalSale: data.totalSale.toLocaleString(),
                    totalOrders: data.totalOrders.toLocaleString(),
                    todaysOrderCount: data.todaysOrderCount.toLocaleString(),
                    todaysSale: data.todaysSale.toLocaleString(),
                });
            }
        });
    }

    render() {
        if (atob(sessionStorage.getItem("zutp")) === "SA") {
            return (
                <div>
                    <Title title="Zadish Admin" />
                    <div style={styles.flexColumn}>
                        Coming Soon...
                    </div>
                </div>
            );
        }
        return (
            <div style={styles.container}>
                <Title title="Dashboard" />
                <div style={styles.flexColumn}>
                    <div style={styles.flex}>
                        <CountCard
                            title="Today's Order Count"
                            value={this.state.todaysOrderCount}
                            icon={TodaysSale}
                            bgColor="#7af442" />
                        <CountCard
                            title="Today's Sale"
                            value={`Rs ${this.state.todaysSale}`}
                            icon={TodaysOrderCount}
                            bgColor="#d641f4" />
                        <CountCard
                            title="Total Sale"
                            value={`Rs ${this.state.totalSale}`}
                            icon={TotalSale}
                            bgColor="#f44336" />
                    </div>
                    <div style={styles.flex}>
                        <CountCard
                            title="Current Month Sale"
                            value={`Rs ${this.state.currentMonthSale}`}
                            icon={CurrentMonthSale}
                            bgColor="#31708f" />
                        <CountCard
                            title="Previous Month Sale"
                            value={`Rs ${this.state.previousMonthSale}`}
                            icon={PreviousMonthSale}
                            bgColor="#4caf50" />
                        <CountCard
                            title="Total Orders Delivered"
                            value={this.state.totalOrders}
                            icon={TotalOrders}
                            bgColor="#ff9800" />
                    </div>
                </div>
            </div>
        );
    }
}
export default Dashboard;